import { post,get,postJson,put,imagePost,deleteApi} from '../axios'

/**
 * 商品模块及分析
 */

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/ware'
const RESOURCE_BASE_PATH = '/ware'
/*
 * 商品复购分析
 * */
export const reBuy = p => get(`${RESOURCE_BASE_PATH}/analyze/reBuy`, p);

/*
 * 商品复购分析数据导出
 * */
export const reBuyExport = p => get(`${RESOURCE_BASE_PATH}/export/reBuy`, p);

/*
 *  获取商品连带分析营销客户的电话 
 * */
export const getBindPhones = p => get(`${RESOURCE_BASE_PATH}/getBindPhones`, p);

/*
 * 商品连带分析
 * */
export const bindSell = p => get(`${RESOURCE_BASE_PATH}/analyze/bindSell/v2`, p);

/*
 *获取商品复购分析营销客户的电话
 * */
export const getReBuyBuyerPhones = p => get(`${RESOURCE_BASE_PATH}/getReBuyBuyerPhones`, p);

// 获取用户菜单列表
export const getSeller = p => get(`/seller/current`, p);


/*
 * 获取店铺类目
 * */
export const getSellercats = p => get(`${RESOURCE_BASE_PATH}/category/all`, p);

/*
 * 获取店铺商品
 * */
export const getTaobaoItemList = p => postJson(`${RESOURCE_BASE_PATH}/all`, p);

/*
 * 客户营销会员分群分页获取商家sku列表
 * */
export const getTaobaoItemListSku = p => postJson(`${RESOURCE_BASE_PATH}/sku/page`, p);

/*
 * 删除商品监控
 * */
export const delBindsell = p => put(`/sku/monitor/bindSell/${p}`);

/*
 * 添加商品监控
 * */
export const addBindsell = p => postJson(`/sku/monitor/bindSell`,p);
/*
 * 商品监控数
 * */
export const count = p => get(`/sku/monitor/bindSell/count`, p);

// 品牌类目

export const getBrandList = p => get(`/memberLabel/getBrandList`, p);


// 导出数据

export const popCommentWareAnalysisExport = p => get(`/popCommentWareAnalysis/analysis/export?${p}`);

/*
 * 将已选spu或sku加入到分组
 * */
export const addToGroup = p => postJson(`/ware/addToGroup`, p);

/*
 * 获取商品分组列表
 * */
export const getGroupList = p => get(`/ware/getGroupList`, p);

/*
 * 删除商品分组
 * */
export const delSkuGroup = p => deleteApi(`/ware/delSkuGroup/${p}`);

/*
 * 查询分组下所有商品
 * */
export const getSkuListByGroup = p => get(`/ware/getSkuListByGroup/${p}`);
/*
 * 导入SKU-手动输入
 * */
export const SKUinputText = p => postJson(`/ware/importSku/inputText`,p);
/*
 * 导入SKU-文件上传
 * */
export const importSkuFile = p => imagePost(`/ware/importSku/file`,p);

